import type { UnmatchedPresenter, UnmatchedPresenterReason } from '@/api/webs'

/**
 * How each reason the BigMarker speaker import gives reads to a PM (ORB-911).
 *
 * ⚑ Shared by the main app's Details banner and the Console's Speakers panel (ORB-965), so the two
 * apps describe the same presenter in the same words.
 */
const REASON_TEXT: Record<UnmatchedPresenterReason, string> = {
  NoEmail: 'No email',
  NoLinkedIn: 'No LinkedIn URL',
  LinkedInNotFound: 'LinkedIn profile not found',
  LookupFailed: 'LinkedIn lookup failed',
}

/** The reason in words, or the raw value for one the server added after this build. */
export function unmatchedReasonText(presenter: UnmatchedPresenter): string {
  return REASON_TEXT[presenter.Reason] ?? presenter.Reason
}

/** "3 BigMarker presenters weren't added as speakers", singular for one. */
export function unmatchedPresentersHeading(count: number): string {
  return count === 1
    ? '1 BigMarker presenter wasn’t added as a speaker'
    : `${count} BigMarker presenters weren’t added as speakers`
}
